<template>
    <div
        class="relative inline-flex flex-shrink-0 items-center text-black hover:text-red-500 focus:outline-none transition duration-300 ease-in-out cursor-pointer"
        :class="{ 'text-red-500': openDropdown }"
        @click="openDropdown = !openDropdown"
        @keydown.esc="openDropdown = false"
        v-on-clickaway="closeDropdown"
        tabindex="0"
    >
        <slot name="dropdown-toggle"></slot>
        <transition
            enter-active-class="transition ease-out duration-100 transform"
            enter-class="opacity-0 scale-95"
            enter-to-class="opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75 transform"
            leave-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-95"
        >
            <slot name="dropdown-content" v-if="openDropdown"></slot>
        </transition>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
export default {
    data: () => ({
        openDropdown: false,
    }),
    methods: {
        closeDropdown() {
            this.openDropdown = false;
        },
    },
    mixins: [clickaway],
};
</script>
